import { render, staticRenderFns } from "./applyAfterSales.vue?vue&type=template&id=5fadf2ac&"
import script from "./applyAfterSales.vue?vue&type=script&lang=js&"
export * from "./applyAfterSales.vue?vue&type=script&lang=js&"
import style0 from "./applyAfterSales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports